export const is = function (value) {
  try {
    var roles = JSON.parse(localStorage.getItem("jsPermissions")).roles;
  } catch (err) {
    return false;
  }

  var _return = false;
  if (!Array.isArray(roles)) {
    return false;
  }
  if (value.includes("|")) {
    value.split("|").forEach(function (item) {
      if (roles.includes(item.trim())) {
        _return = true;
      }
    });
  } else if (value.includes("&")) {
    _return = true;
    value.split("&").forEach(function (item) {
      if (!roles.includes(item.trim())) {
        _return = false;
      }
    });
  } else {
    _return = roles.includes(value.trim());
  }
  return _return;
};
